import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Config } from '../../../../_store/config';

@Component({
  selector: 'app-query-detail',
  templateUrl: './query-detail.component.html',
  styleUrls: ['./query-detail.component.scss']
})
export class QueryDetailComponent implements OnInit {
  queryId: string = '';
  loading = true;
  errorMsg = '';
  queryDetail: any = {};

  constructor(private route: ActivatedRoute, private http: HttpClient) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.queryId = params.get('queryNo') || '';
      if (this.queryId) {
        this.fetchQueryDetail();
      } else {
        this.loading = false;
        this.errorMsg = 'No Query ID provided.';
      }
    });
  }

  fetchQueryDetail() {
    this.loading = true;
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    });
    const url = `${Config.urls.GETTICKET}?id=${encodeURIComponent(this.queryId)}`;
    this.http.get(url).subscribe(
      (response: any) => {
        this.queryDetail = response.data;
        this.loading = false;
      },
      (error) => {
        this.errorMsg = 'Failed to fetch query details.';
        this.loading = false;
      }
    );
  }
}
